<template>
  <br>
  <span class="msg_marketing">Digital Appointments </span>
  <br>
  <span class="msg_marketing">no <i class="fa fa-volume-control-phone" aria-hidden="true"></i>, 24/7, optimize your schedule</span>
  <br><br>
  <span> Create an <span style="cursor: pointer;color: #fa755a" @click="myScroll()">account</span> and your web site will offer appointment service for your clients </span>
  <br>
  <span>What types of businesses can use it ? Check out some use cases here after....</span>
  <hr>
    <hello-business></hello-business>
    <div class="container">
        <div style="font-size: 60px"> Sign-in</div>
        <span class="psw">Forgot Access Key? <a href="http://www.ulip.ee/support" target="_blank">Get support</a></span>
        <input type="password" placeholder="Enter Access Key" id="psw" v-model="ak_code" required>
        <label>
            <input type="checkbox" v-model="pak" name="remember">
            <span style="font-size: 12px">Remember Access Key / Sign-in</span>
        </label>
        <button type="submit" :disabled="offSignIn" @click.prevent="sign_in">
            <i class="fa fa-sign-in" aria-hidden="true"></i>&nbsp;
            Sign-in
        </button>

        <button class="reqbtn" @click="goToNewBusiness">
            <i class="fa fa-user-plus" aria-hidden="true"></i> New Account
        </button>
        <button class="reqbtn" >
          <i class="fa fa-heart" aria-hidden="true"></i>
          <a style="text-decoration: none" href="mailto:?to=dnan66@gmail.com&subject=Request Trial Code &body=Hello sAPPo!">
            Request Trial Key
          </a>
        </button>
        <hr>
        <button class="customerbtn" @click="goToCustomerUI">
            <i class="fa fa-share" aria-hidden="true"></i>
            &nbsp;<i class="fa fa-user-circle" aria-hidden="true"></i> Client interface
        </button>
      <div style="margin-top: 40px;font-size: 12px"><i class="fa fa-copyright" aria-hidden="true"></i> 2024, ulip ou</div>
    </div>
</template>

<script>
    import {getBaseURL} from '../url_endpoints.js'
    import HelloBusiness from "../components/HelloBusiness.vue";
    export default {
        components: {HelloBusiness},
        name:'Business',
        data() {
            return {
                ak_code:null,
                baseURL:null,
                pak:null,
            }
        },
        mounted() {
            this.baseURL = getBaseURL()
            this.ak_code = localStorage.getItem('pak')
            this.pak = this.ak_code
        },
        computed: {
           offSignIn() {
               return !this.ak_code
           }
        },
        methods: {
            myScroll() {
             window.scrollTo({top:4200})
            },
            goToCustomerUI() {
                //console.log('switch to user interface...')
                this.$store.commit('setBusinessUi',!this.$store.getters.getBusiness)
                this.$router.push('/client')
                window.scrollTo(0,0)
            },
            goToNewBusiness() {
                this.$router.push('/new_business')
                window.scrollTo(0,0)
            },
            sign_in() {
                // check the access key code & add auth token
                const tk ='69bd7de4f45da9d7a12bde4102cf25db97db6d0df6b98f130b64cfe9a6a2b12d'
                fetch(this.baseURL + '/business?code='+this.ak_code+'&token='+tk, {
                    methods: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(rsp => {
                    return rsp.json()
                }).then( data => {
                    if(data.length > 0 ){
                        // found resource in backend
                        //console.log(data)
                        this.$store.commit('setLoginState',true)
                        // save business object
                        this.$store.commit('setCurrentBusiness',data[0])
                        // check to store local pak
                        if(this.pak) {
                            localStorage.setItem('pak',this.ak_code)
                        }else {
                            const ak = localStorage.getItem('pak')
                            if(!ak) {
                                // skip
                            }else {
                                localStorage.removeItem('pak')
                            }
                        }
                        this.$router.push('/features')
                        window.scrollTo(0,0)
                    }else {
                        throw new Error('Access Key Code not found!')
                    }
                }).catch(err => {
                    // backend not running or resource not found in backend
                    if(err.message === 'Access Key Code not found!') {
                        alert('BackEnd Server response:\n'+ err.message)
                    } else {
                        alert('BackEnd Server could be down! \n' + err.message)
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    body {
        background-color: black;
        height: 100vh;
    }
    input[type=text], input[type=password] {
        width: 100%;
        padding: 10px 20px;
        margin: 5px 0;
        display: inline-block;
        border: 1px solid #ccc;
        box-sizing: border-box;
    }
    button {
        background-color: #4CAF50;
        color: white;
        padding: 14px 20px;
        margin: 8px 0;
        border: none;
        cursor: pointer;
        width: 100%;
        opacity: 0.8;
        font-size: 25px;
    }
    button:hover {
        opacity: 1.0;
    }
    button:disabled {
        background-color: darkgray;
    }
    .customerbtn {
        padding: 10px 18px;
        background-color: dodgerblue;
    }
    .reqbtn {
        //width: auto;
        padding: 10px 18px;
        background-color: #20b2aa;
    }
    .imgcontainer {
        text-align: center;
        margin: 24px 0 12px 0;
    }
    img.avatar {
        width: 20%;
        border-radius: 80%;
    }
    .container {
        padding: 10px 30%;
        margin-top: 420vh;
    }
    span.psw {
        float: right;
        padding-top: 16px;
        font-size: 10px;
    }
    span.akc {
        font-weight: bold;
        font-size: 20px;
    }

    a {
        color: yellow;
    }
    a:visited {
        color: lightsalmon;
    }
    .msg_marketing {
      font-size: 40px;
      font-family: AppleGothic,fantasy;
    }
    /* Change styles for span and cancel button on extra small screens */
    @media screen and (max-width: 601px) {
        .container {
            padding: 16px;
        }
        .cancelbtn {
            width: 100%;
        }
        .reqbtn {
            width: 100%;
        }
        img.avatar {
            width: 40%;
        }
        h1 {
            font-size: 12px;
        }
      .msg_marketing {
        font-size: 20px;
      }
    }
    @media screen and (max-width: 300px) {
        .container {
            margin-top: 390vh;
        }
      .msg_marketing {
        font-size: 20px;
      }
    }
</style>

